var exports = {
  "nM": "ForkKlipyGifPickerHeader.module__row___TDFOU0",
  "wx": "ForkKlipyGifPickerHeader.module__header___TDFOU0",
  "UK": "ForkKlipyGifPickerHeader.module__poweredBy___TDFOU0",
};

module.exports = exports;
